import MatchedMap from 'utilities/src/matchedMap';
import { InputThemeEnum } from '../../shared/utils/themes';
import { TBoxTypeEnum } from '../../shared/utils/types';

const checkboxInputCheckedThemeClasses = new MatchedMap([
  [InputThemeEnum.Dark, '[&:checked~label>div]:bg-white [&:checked~label>div]:border-white'],
  [InputThemeEnum.Light, '[&:checked~label>div]:bg-primary-600 [&:checked~label>div]:border-primary-600'],
]);

const radioInputCheckedThemeClasses = new MatchedMap([
  [InputThemeEnum.Dark, ''],
  [InputThemeEnum.Light, ''],
]);

const inputThemeClasses = new MatchedMap([
  [TBoxTypeEnum.Checkbox, checkboxInputCheckedThemeClasses],
  [TBoxTypeEnum.Radio, radioInputCheckedThemeClasses],
]);

const checkboxBlogTheme = {
  inputThemeClasses,
};

export default checkboxBlogTheme;
